import React from 'react';
import 'twin.macro';
import Button from 'components/Buttons/Button';
import { useTranslation } from 'react-i18next';

interface Props {
  onDuplicateShareEDT?: () => void;
}

export function EdtToolbarLeft(props: Props) {
  const { t } = useTranslation(['common']);
  const { onDuplicateShareEDT } = props;
  if (onDuplicateShareEDT) {
    return (
      <Button onClick={onDuplicateShareEDT}>
        {t('common:buttons.copyAndModify')}
      </Button>
    );
  }
  return <div tw="hidden sm:block" />;
}
